import React from 'react'
import { BankIcon, CardIconBuilder } from '../../../../assets/icons'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'
import { ListItem } from '../../../../ui/atoms/builder-2.0/ListItem'
import { EndIcon } from '../../../../ui/add-payment-method-components/EndIcon'
import { Row } from '../../../../ui/atoms/Grid'
import BuilderBottomModal from '../../../../ui/molecules/BuilderBottomModal'

interface AddNewPaymentMethodModalProps {
  acceptAchPayment: boolean
  cardPaymentAvailable: boolean
  onConnectBank: () => void
  onLinkCard: () => void
  onClose: () => void
  alignDirection?: string
}

export const AddNewPaymentMethodModal: React.FC<AddNewPaymentMethodModalProps> =
  observer(
    ({
      onConnectBank,
      onLinkCard,
      onClose,
      acceptAchPayment,
      cardPaymentAvailable,
    }) => {
      const { t } = useTranslation('global')

      return (
        <BuilderBottomModal
          height={300}
          visible={true}
          onClose={onClose}
          testID={'add-new-payment-method-modal'}
        >
          <Row
            style={{ marginHorizontal: 0 }}
            testID={'add-new-payment-method-row'}
          >
            <ListItem
              onPress={onConnectBank}
              icon={<BankIcon />}
              title={t('ConnectYourBank')}
              subtitle={t('ConnectionsAreEncrypted')}
              endIcon={<EndIcon />}
              testID={'connect-bank'}
              disabled={!acceptAchPayment}
            />
            <ListItem
              onPress={onLinkCard}
              icon={<CardIconBuilder />}
              title={t('LinkYourCard')}
              subtitle={t('CardDetailsAreTokenized')}
              endIcon={<EndIcon />}
              testID={'link-card'}
              disabled={!cardPaymentAvailable}
            />
          </Row>
        </BuilderBottomModal>
      )
    },
  )
